import { Controller } from 'stimulus'
import { jsRequest } from '@react/helpers/fetch'

const SKIPPED = ['_method', 'authenticity_token', 'utf8']

// Sent as JSON: a long action list exceeds Rack's 4,096 form fields limit.
export default class extends Controller {
  submit(event) {
    event.preventDefault()
    if (this.submitting) return

    const button = event.submitter
    this.submitting = true
    if (button) button.disabled = true
    jsRequest(this.element.action, {
      method:    'PATCH',
      body:      this._params(),
      onFailure: () => {
        this.submitting = false
        if (button) button.disabled = false
      }
    })
  }

  _params() {
    const params = {}

    for (const [name, value] of new FormData(this.element)) {
      if (SKIPPED.includes(name)) continue

      const keys    = name.replace(/\]/g, '').split('[')
      const isArray = keys[keys.length - 1] === ''
      if (isArray) keys.pop()

      const last = keys.pop()
      const node = keys.reduce((obj, key) => obj[key] = obj[key] || {}, params)

      if (isArray) node[last] = [...(node[last] || []), value]
      else         node[last] = value
    }

    return params
  }
}
